<template>
  <div class="post">
    <h3 class="title">职位</h3>
    <div class="content-wrapper">
      <a-input-search
        placeholder="输入职位名搜索"
        allowClear
        @search="getData()"
        v-model="searchText"
        enterButton
      />
      <a-list
        size="small"
        itemLayout="vertical"
        :bordered="true"
        style="margin-top:20px"
        :pagination="pagination"
        :loading="loading"
      >
        <template v-for="item in dataSource">
          <a-list-item :key="item.id">
            <a-row
              type="flex"
              justify="space-between"
              align="middle"
              style="padding-bottom:5px"
            >
              <a-col class="flex ellipsis" span="19">
                <span class="name">
                  <b>{{ item.name }}</b>
                </span>
                <span class="ji" v-if="item.is_urgent == '1'">急</span>
                <span class="hc" v-if="item.is_mhc == '1'">多HC</span>
              </a-col>
              <a-col>
                <a-button
                  size="small"
                  type="primary"
                  ghost
                  @click="sendPostMessage(item)"
                  >发送</a-button
                >
              </a-col>
            </a-row>
            <a-row>
              <a-col>
                <b>
                  <span style="color:#FC5646">
                    {{
                      `${item.hunter_salary_min}-${item.hunter_salary_max}万`
                    }}
                  </span>
                </b>
                <a-divider type="vertical" />
                <span>{{ item.city_name || item.province_name }}</span>
                <a-divider type="vertical" />
                <span>{{ item.education_name }}</span>
              </a-col>
            </a-row>
            <a-row>
              <a-col class="ellipsis">
                <span>{{ item.second_category_name }}</span>
                <a-divider type="vertical" />
                <span>{{ item.company.name }}</span>
              </a-col>
            </a-row>
          </a-list-item>
        </template>
      </a-list>
    </div>
  </div>
</template>

<script>
import Api from "@/api";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapState, mapMutations } = createNamespacedHelpers("im");
export default {
  name: "postCard",
  data() {
    return {
      loading: false,
      dataSource: [],
      searchText: "",
      pagination: {
        hideOnSinglePage: true,
        simple: true,
        size: "small",
        pageSize: 4,
        current: 1,
        total: 0,
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: false,
        showSizeChanger: false,
        onChange: e => {
          this.getData(e);
        }
      }
    };
  },
  inject: ["boxScrollToBottom"],
  components: {},
  computed: {
    ...mapState(["currentConversation"]),
    ...mapGetters(["toAccount", "currentConversationType"])
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapMutations(["pushCurrentMessageList"]),
    async getData(current) {
      this.loading = true;
      this.pagination.current = current || 1;
      let params = {
        name: this.searchText,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      try {
        var response = await Api.post.getPostList(params);
        this.pagination.total = +response.total;
        this.dataSource = response.list;
      } catch (err) {}
      this.loading = false;
    },
    async sendPostMessage(record) {
      let job = {
        id: record.id,
        name: record.name,
        is_urgent: record.is_urgent,
        is_mhc: record.is_mhc,
        hunter_salary_min: record.hunter_salary_min,
        hunter_salary_max: record.hunter_salary_max,
        city_name: record.city_name,
        province_name: record.province_name,
        education_name: record.education_name,
        second_category_name: record.second_category_name,
        company: {
          name: record.company.name
        }
      };
      const message = this.$tim.createCustomMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: {
          data: JSON.stringify({ type: "job", data: JSON.stringify(job) })
        }
      });
      this.pushCurrentMessageList(message);
      this.boxScrollToBottom();
      //发送消息
      try {
        await this.$tim.sendMessage(message);
      } catch (e) {
        this.$message.info(e.message);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.post {
  border-left: 1px solid #e7e7e7;
  .title {
    line-height: 48px;
    border-bottom: 1px solid #e7e7e7;
    padding-left: 40px;
  }
  .content-wrapper {
    padding: 10px 20px;
  }
  .flex {
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      margin-right: 5px;
      &.name {
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }
      &.ji {
        font-size: 12px;
        background: #ff6b5d;
        border-radius: 2px;
        height: 18px;
        color: #fff;
        padding: 0 3px;
      }
      &.hc {
        background: #f6b502;
        padding: 0 3px;
        font-size: 12px;
        border-radius: 2px;
        height: 18px;
        color: #fff;
      }
    }
  }
  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
